<template>
  <div v-if="!isError" class="s-captcha">
    <div id="captcha-container"></div>
    <slot name="errors"/>
  </div>
</template>

<script>
import {loadScript} from "../utils";

export default {
  name: "SmartCaptcha",
  props: {
    value: {type: Object}
  },
  data() {
    return {
      widgetId: '',
      token: '',
      isError: false
    }
  },
  computed: {
    smartCaptcha() {
      return window.smartCaptcha
    },
    captchaKey() {
      return this.$store.state.smartCaptchaKey;
    },
  },
  mounted() {
    loadScript('smartcaptcha', 'https://smartcaptcha.yandexcloud.net/captcha.js')
      .then(this.initCaptcha)
      .catch(this.onError)
  },
  beforeDestroy() {
    if (this.smartCaptcha) {
      this.smartCaptcha.destroy(this.widgetId)
    }
  },
  methods: {
    initCaptcha() {
      if (!this.smartCaptcha || !this.captchaKey) {
        this.onError()
        return
      }

      this.widgetId = this.smartCaptcha.render('captcha-container', {
        sitekey: this.captchaKey,
        invisible: true,
        callback: this.onSubmit
      })
    },
    onSubmit(token) {
      this.token = token
      this.$emit('input', token)
      if (this._refreshResolve) {
        this._refreshResolve(token)
        this._refreshResolve = null
      }
    },
    refresh() {
      return new Promise((resolve) => {
        this._refreshResolve = resolve
        if (this.smartCaptcha && this.widgetId !== undefined && !this.isError) {
          if (this.token) {
            this.smartCaptcha.reset(this.widgetId)
            this.token = ''
          }
          this.smartCaptcha.execute(this.widgetId)
        } else {
          this.onError()
        }
      })
    },
    onError() {
      this.isError = true
      this.onSubmit('null')
    }
  }
}
</script>

<style scoped lang="scss">
.s-captcha {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
